module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/77d3dbbe1fe1d4a251f68a2be0f8f5cb.png";